import { render, staticRenderFns } from "./CatalogoPreventivo.vue?vue&type=template&id=ba19365e&"
import script from "./CatalogoPreventivo.vue?vue&type=script&lang=js&"
export * from "./CatalogoPreventivo.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoPreventivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports